import React from 'react';

// Components
import { Row, Column } from '@pella/sash-framework';

// Styles
import styles from './index.module.scss';

const CalendarHeader = () => (
	<Row justify='center'>
		<Column
			xs='12'
			className={styles.rtaCalendar_Header_Wrapper}
		>
			<div className={styles.rtaCalendar_Header_Data}>
				<p>SUN</p>
			</div>
			<div className={styles.rtaCalendar_Header_Data}>
				<p>MON</p>
			</div>
			<div className={styles.rtaCalendar_Header_Data}>
				<p>TUE</p>
			</div>
			<div className={styles.rtaCalendar_Header_Data}>
				<p>WED</p>
			</div>
			<div className={styles.rtaCalendar_Header_Data}>
				<p>THR</p>
			</div>
			<div className={styles.rtaCalendar_Header_Data}>
				<p>FRI</p>
			</div>
			<div className={styles.rtaCalendar_Header_Data}>
				<p>SAT</p>
			</div>
			<hr />
		</Column>
	</Row>
);

export default CalendarHeader;
